import Utility from "@/helper/Utility"
import { DateTime } from "luxon"

export const ClaimNoRegisterModel = function () {
    this.formType = "now"
    this.appointmentLocation = ""
    this.claimDate = new Date()
    this.claimTime = { hours: this.claimDate.getHours(), minutes: this.claimDate.getMinutes() }
    this.appointDate = null
    this.appointTime = null
    this.nameTitle = null
    this.driverName = null
    this.contactNumber = null
    this.citizenId = null
    this.acceptTermsAndCond = false
    this.province = null
    this.provinceName = null
    this.carNo = null
    this.redPlate = false

    this.imgIdCard = null
    this.imgCarPlate = null

    this.lat = 0
    this.lng = 0
    this.lineId = null
}

ClaimNoRegisterModel.prototype.setFormType = function(fType){
    this.formType = fType
    return this
}

/**
 * 
 * @param {import("@/helper/LocationHelper").LatLng} latLng 
 */
ClaimNoRegisterModel.prototype.setLatLng = function (latLng) {
    this.lat = latLng.lat
    this.lng = latLng.lng
    return this
}

/**
 * 
 * @param {*} lineCache 
 * @returns 
 */
ClaimNoRegisterModel.prototype.setLineId = function (lineId) {
    // console.log(lineCache)
    this.lineId = lineId
    return this
}

ClaimNoRegisterModel.prototype.setProvinceName = function (provinceName) {
    this.provinceName = provinceName
}

ClaimNoRegisterModel.prototype.getParams = function () {
    let dtString = null
    if (this.appointDate != null) {
        dtString = DateTime.fromJSDate(this.appointDate).startOf("day").plus({
            hours: this.appointTime.hours,
            minutes: this.appointTime.minutes,
            seconds: 0
        }).toFormat("yyyy-MM-dd'T'HH:mm:ss")
    }

    let json = {
        type: this.formType,
        lineUserId: this.lineId,
        title: this.nameTitle,
        fullname: this.driverName,
        mobile: this.contactNumber,
        licensePlate: this.carNo,
        citizenId: this.citizenId,
        isAcceptConsent: this.acceptTermsAndCond,
        isNewCar: this.redPlate,
        latitude: this.lat,
        longitude: this.lng,
        place: this.appointmentLocation,
        provinceCode: this.province,
        provinceName: this.provinceName
    }

    if(this.formType != "now"){
        json.appointmentDate = dtString
    }

    if (this.imgIdCard != null) {
        json.idCardImage = this.imgIdCard
    }

    if (this.imgCarPlate != null) {
        json.licensePlateImage = this.imgCarPlate
    }

    return Utility.cleanObjectEmptyStr(json)
}